import { Service } from "typedi";
import {
  CreateIdentityProviderBody,
  CreateIdentityProviderResponse,
  FindIdentityProviderByIdResponse,
  FindIdentityProvidersQuery,
  FindIdentityProvidersResponse,
  FindLoginButtonResponse,
  FindLoginButtonsBody,
  UpdateIdentityProviderBody,
  UpdateIdentityProviderResponse,
} from "@flosum-auth/contracts";
import { RestService } from "~shared/services/rest.service";

@Service()
export class IdentityProvidersService {
  constructor(private readonly restService: RestService) {}

  public find(query: FindIdentityProvidersQuery): Promise<FindIdentityProvidersResponse> {
    return this.restService.get(`/v1/identity-providers`, query);
  }

  public findById(id: number): Promise<FindIdentityProviderByIdResponse> {
    return this.restService.get(`/v1/identity-providers/${id}`);
  }

  public findLoginButtons({ tenantName, state }: FindLoginButtonsBody): Promise<FindLoginButtonResponse> {
    return this.restService.post(`/v1/identity-providers/login-buttons`, {
      tenantName,
      state,
    });
  }

  public create(body: CreateIdentityProviderBody): Promise<CreateIdentityProviderResponse> {
    return this.restService.post(`/v1/identity-providers/`, body);
  }

  public update(id: number, body: UpdateIdentityProviderBody): Promise<UpdateIdentityProviderResponse> {
    return this.restService.patch(`/v1/identity-providers/${id}`, body);
  }

  public enable(id: number): Promise<void> {
    return this.restService.patch(`/v1/identity-providers/${id}/enable`);
  }

  public async disable(id: number): Promise<void> {
    return this.restService.patch(`/v1/identity-providers/${id}/disable`);
  }

  public delete(id: number): Promise<void> {
    return this.restService.delete(`/v1/identity-providers/${id}`);
  }
}
